<template>
  <section
    :class="[oneLine ? 'd-flex justify-space-between align-center' : '']"
  >
    <div
      id="start-time-input_container"
      :class="[oneLine ? 'time-container' : '']"
    >
      <v-text-field
        id="start-time-input"
        v-model="startTime"
        type="time"
        :disabled="disabled"
        color="indigo"
        :label="$t('input.startTimeLabel')"
        :rules="[rules.startTimeAfterEnd]"
        @input="updateTime('start')"
      ></v-text-field>
    </div>

    <span v-if="oneLine && !isMobileViewPort">&mdash;</span>

    <div
      id="end-time-input_container"
      :class="[oneLine ? 'time-container' : '']"
    >
      <v-text-field
        id="end-time-input"
        v-model="endTime"
        type="time"
        :disabled="disabled"
        color="indigo"
        :label="$t('input.endTimeLabel')"
        :rules="[rules.endTimeBeforeStart, rules.endTimeBeforeMin]"
        @input="updateTime('end')"
      ></v-text-field>
    </div>
  </section>
</template>

<script>
import baseMixin from '@/mixins/baseMixin'

export default {
  name: 'TimeRangeInput',
  mixins: [baseMixin],
  props: {
    start: {
      type: String,
      required: true,
    },
    end: {
      type: String,
      required: true,
    },
    minEndTime: {
      type: String,
      default: '12:00',
    },
    disabled: {
      type: Boolean,
    },
    oneLine: {
      type: Boolean,
    },
  },
  data() {
    return {
      startTime: '09:00',
      endTime: '15:30',
      rules: {
        required: (v) => !!v || this.$t('input.inputRequiredValidationText'),
        startTimeAfterEnd: () =>
          this.startTime
            ? !this.isStartInvalid ||
              this.$t('input.startTimeBeforeEndValidationText')
            : true,
        endTimeBeforeStart: () =>
          this.endTime
            ? !this.isEndInvalid ||
              this.$t('input.endTimeBeforeStartValidationText')
            : true,
        endTimeBeforeMin: () =>
          this.endTime
            ? !this.isEndTimeBeforeMinimum ||
              this.$t('input.endTimeBeforeMinEndValidationText', {
                minEndTime: `${this.minEndTime} (24 hour time)`,
              })
            : true,
      },
    }
  },
  computed: {
    isStartInvalid() {
      return this.startTime > this.endTime
    },
    isEndInvalid() {
      return this.endTime < this.startTime
    },
    isEndTimeBeforeMinimum() {
      if (!this.minEndTime) return false
      return this.endTime < this.minEndTime
    },
  },
  watch: {
    start: {
      handler() {
        this.startTime = this.start
      },
    },
    end: {
      handler() {
        this.endTime = this.end
      },
    },
  },
  created() {
    this.startTime = this.start
    this.endTime = this.end
  },
  methods: {
    updateTime() {
      this.$emit(`timeUpdated`, {
        start: this.startTime,
        end: this.endTime,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.time-container {
  width: 48%;
}
</style>
